import type { BoggleResolvedChallengeBonus } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBonusDisplayFromDefinition } from '~/boggle/config/bonuses/formatResolvedBonusDisplay'
import type { BoggleChallengeBonusResolverContext } from '~/boggle/lib/challenge/resolveModFamily'
import type { BoggleBonusValue } from '../types'
import type { BoggleChallengeBonusDefinition } from '../bonusDefinition'

export const vowelScarcityBonusDefinition: BoggleChallengeBonusDefinition = {
  description: 'Word contains only one vowel',
  id: 'vowel-scarcity',
  name: "Vow'l Crunch",
  parameterDefinitions: {},
  selectionWeight: 1,
  shortLabel: 'One vowel per word',
}

export function resolveVowelScarcityBonus(
  family: BoggleChallengeBonusDefinition,
  rngState: number,
  _context: BoggleChallengeBonusResolverContext,
  value: BoggleBonusValue,
): {
  mod: BoggleResolvedChallengeBonus
  rngState: number
} {
  const display = formatResolvedBonusDisplayFromDefinition(family, {})

  return {
    mod: {
      description: display.description,
      effects: [],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [
        {
          kind: 'vowel-scarcity',
        },
      ],
      parameters: {},
      shortLabel: display.shortLabel,
      value,
    },
    rngState,
  }
}
